import { styled } from '../../../stitches.config';

export const Container = styled('div', {
  position: 'relative',
});
